<script lang="ts" setup>
const route = useRoute()
const { t } = useI18n()
const i18nHead = useLocaleHead({
    addDirAttribute: true,
    identifierAttribute: 'id',
    addSeoAttributes: true,
})
const title = computed(() =>
    route.meta.name ? t(route.meta.name) : t('passionEquip'),
)
useHead({
    htmlAttrs: {
        lang: i18nHead.value.htmlAttrs?.lang,
        class:
      'bg-background-500 dark:bg-neutral-900 w-full h-full h-max min-h-screen',
    },
    title: title,
    link: [...(i18nHead.value.link || [])],
    meta: [...(i18nHead.value.meta || [])],
    bodyAttrs: {
        class:
      'bg-background-500 dark:bg-neutral-900 w-full h-full h-max min-h-screen',
    },
})
</script>

<template>
  <LayoutDefaultRoot>
    <slot />
  </LayoutDefaultRoot>
</template>
